import { formTypes } from '.';
import { generalConceptsValueLabelList } from '../puc';

export const purchasesFields = {
  supplierName: { key: 'supplierName', label: 'Proveedor', type: formTypes.selectComplete, options: [] },
  cufe: {
    key: 'cufe',
    label: 'Cufe de cuenta de cobro',
    placeholder: '3a5g5gadft1435asst54'
  },
  description: {
    key: 'description',
    label: 'Descripción (Opcional)',
    placeholder: 'Ej: Comestibles'
  },
  issueDate: { key: 'issueDate', label: 'Fecha de creación', type: formTypes.date },
  dueDate: { key: 'dueDate', label: 'Fecha de vencimiento', type: formTypes.date },
  id: { key: 'id', label: 'Número de cuenta de cobro', placeholder: '1234567' },
  invoiceAccountId: {
    key: 'invoiceAccountId',
    label: 'Cuenta contable general',
    type: formTypes.select,
    options: generalConceptsValueLabelList
  },
  lineExtensionAmount: {
    key: 'lineExtensionAmount',
    label: 'Monto total (antes de retenciones)',
    type: formTypes.money,
    placeholder: '$300,000.00'
  },
  discounts: { key: 'discounts', label: 'Descuentos', type: formTypes.money, placeholder: '$300,000.00' },
  payableAmountAfterRetentions: {
    key: 'payableAmountAfterRetentions',
    label: 'Monto total (después de retenciones)',
    type: formTypes.money,
    disabled: true,
    placeholder: '$300,000.00'
  }
};
